export default "__VITE_ASSET__C5bSSCR9__"